/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  PostApiVrAuthValidateCodeParams
} from '../generated.schemas';




  export const getVrauth = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Generates a VR authentication code without email requirement.
Called by VR device to get a code that user will validate from website.
 */
const postApiVrAuthGenerateCode = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/vr-auth/generate-code`,undefined,options
    );
  }
/**
 * @summary Validates a VR authentication code and links it to authenticated user's account.
User must be authenticated via JWT token in Authorization header.
Called by user from website to authorize VR device.
User only needs to enter the 6-digit code they see on VR screen.
 */
const postApiVrAuthValidateCode = (
    params?: PostApiVrAuthValidateCodeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/vr-auth/validate-code`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * @summary Gets the status of a VR authentication session.
 */
const getApiVrAuthSessionStatusSessionId = (
    sessionId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/vr-auth/session-status/${sessionId}`,options
    );
  }
return {postApiVrAuthGenerateCode,postApiVrAuthValidateCode,getApiVrAuthSessionStatusSessionId}};
export type PostApiVrAuthGenerateCodeResult = AxiosResponse<void>
export type PostApiVrAuthValidateCodeResult = AxiosResponse<void>
export type GetApiVrAuthSessionStatusSessionIdResult = AxiosResponse<void>
